var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlphaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,20c-2.53,0-3.8-1.92-4.65-4.24C14.51,18.12,12.09,20,9.05,20c-2.59,0-4.51-.68-5.7-2a6.61,6.61,0,0,1-1.27-5.34C2.51,9,5.76,4,10.74,4c3.91,0,5.32,3.55,6.27,6.9a33.25,33.25,0,0,0,2-5.17A1,1,0,0,1,21,6.27a33.15,33.15,0,0,1-3.19,7.39C18.58,16.39,19.35,18,21,18a1,1,0,0,1,0,2ZM10.74,6C7,6,4.4,10.08,4.07,12.89a4.67,4.67,0,0,0,.78,3.77c.79.89,2.2,1.34,4.2,1.34,2.74,0,4.94-2.14,6.56-4.64-.06-.22-.12-.44-.17-.65C14.34,8.66,13.42,6,10.74,6Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphaIcon);
export default __webpack_public_path__ + "static/media/AlphaIcon.88363f02e45716a9150319181a7c26c8.svg";
export { ForwardRef as ReactComponent };